import {
  INITIAL_STATE_ADVANCE_CRUISE_REPORT,
  REQUEST_GENERATE_ADVANCE_CRUISE_REPORT,
  GENERATE_ADVANCE_CRUISE_REPORT_SUCCESS,
  GENERATE_ADVANCE_CRUISE_REPORT_ERROR,
} from "../../../actions/reservations/advanceCruise/generateAdvanceCruiseReport";

const initialState = {
  data: File,
  processing: false,
  fetching: false,
  message: "",
  error: "",
};

const advanceCruiseReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIAL_STATE_ADVANCE_CRUISE_REPORT: {
      return {
        ...state,
        data: "",
        processing: false,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case REQUEST_GENERATE_ADVANCE_CRUISE_REPORT: {
      return {
        ...state,
        data: "",
        processing: false,
        fetching: true,
        message: "",
        error: "",
      };
    }
    case GENERATE_ADVANCE_CRUISE_REPORT_SUCCESS: {
      return {
        ...state,
        data: action.data,
        processing: false,
        fetching: false,
        message: "data send succesfully",
        error: "",
      };
    }
    case GENERATE_ADVANCE_CRUISE_REPORT_ERROR: {
      return {
        ...state,
        data: "",
        processing: false,
        fetching: false,
        message: "",
        error: action.error,
      };
    }
    default: {
      return state;
    }
  }
};
export default advanceCruiseReportReducer;
